export default __webpack_public_path__ + "static/media/wiredtree.e005fbc3.svg";